import {
  ComBoxSensorType,
  ROOM_SENSOR_INDEX,
} from "@/data/models/ComBoxSensorData";

export function isConnectedOptionalSensor(sensorType?: ComBoxSensorType) {
  return (
    sensorType !== undefined &&
    sensorType !== ComBoxSensorType.EMPTY &&
    sensorType !== ComBoxSensorType.UNKNOWN
  );
}

export function getVisibleSensorIndexes(
  sensorTypes: ComBoxSensorType[],
  totalNumberOfSensors: number
) {
  const indexes: number[] = [];

  for (let index = 0; index < totalNumberOfSensors; index++) {
    if (
      index === ROOM_SENSOR_INDEX ||
      isConnectedOptionalSensor(sensorTypes[index])
    ) {
      indexes.push(index);
    }
  }

  return indexes;
}
